/* Live preview of the iced name tag. Keeps the SVG text inside the bone however
   long the name is, and never claims more letters than Jade can actually pipe. */
(function () {
  function fit(text, name) {
    var n = (name || '').trim();
    text.textContent = n === '' ? 'Your dog' : n;
    text.setAttribute('opacity', n === '' ? '.45' : '1');
    var len = Math.max(n.length, 7);
    text.setAttribute('font-size', len <= 7 ? 44 : Math.max(20, Math.round(310 / len * 1.55)));
  }
  function wire(root) {
    if (root.dataset.wcWired === '1') return;      // never re-wire: writing the preview
    root.dataset.wcWired = '1';                    // is itself a DOM change
    var name = root.querySelector('[data-wc-name]');
    var text = root.querySelector('[data-wc-tag-text]');
    var count = root.querySelector('[data-wc-count]');
    var cap = root.querySelector('[data-wc-tag-cap]');
    var age = root.querySelector('[data-wc-age]');
    if (!name) return;
    function update() {
      if (text) fit(text, name.value);
      if (count) count.textContent = name.value.length;
      if (cap) {
        var a = age && age.value ? age.value.replace(/\D/g, '') : '';
        cap.textContent = name.value.trim()
          ? (a ? 'Turning ' + a + '. Hand-piped, just like this.' : 'Hand-piped, just like this.')
          : 'Hand-piped, just like this';
      }
    }
    name.addEventListener('input', update);
    if (age) age.addEventListener('input', update);
    update();
  }
  function init() { document.querySelectorAll('[data-wc-perso]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Shopify re-renders sections in the editor and swaps variant markup on the
  // product page; listen for those rather than watching the whole document.
  ['shopify:section:load', 'shopify:section:select', 'variant:changed', 'product:variant-change']
    .forEach(function (e) { document.addEventListener(e, init); });
})();
